import { useEffect, useState } from "react";
import { useParams } from 'react-router-dom';
import CustomPanelTab from "../../common/CustomPanelTab";

import BRGPatientPrompt from "../BRGPatientPrompt";
import EmailTemplate from "../EmailTemplate";
import BRGPatientEmailLog from "../BRGPatientEmailLog";
import TherapistReminder from "../TherapistReminder";


function PanelEmail() {
    const { tab } = useParams();
    const [activeTab, setActiveTab] = useState(null);
    const tabs = [
        { "name": "Discharged Patients", "path": "/discharged-patients" },
        { "name": "Therapist Reminder", "path": "/therapist-reminder" },
        { "name": "Templates", "path": "/templates" },
        { "name": "Logs", "path": "/logs" },
    ];

    useEffect(() => {
        const link = (process.env.REACT_APP_ENVIRONMENT === "PROD" ? process.env.REACT_APP_ADMIN_URL : process.env.REACT_APP_ADMIN_URL_DEV);
        activeTab?.path && window.history.pushState({}, "", `${link}email-panel${activeTab?.path}`);
    }, [activeTab]);

    return (
        <div id="email-panel" className="custom-panel">
            <div className="panel-header">
                <h4>Email</h4>
            </div>
            <CustomPanelTab tabs={tabs}
                defaultTab={tabs?.find(t => t?.path == ('/' + tab))}
                setActiveTab={setActiveTab} />

            <div className="panel-content">
                {
                    activeTab?.name == "Discharged Patients" && <BRGPatientPrompt />
                }
                {
                    activeTab?.name == "Templates" && <EmailTemplate />
                }
                {
                    activeTab?.name == "Logs" && <BRGPatientEmailLog />
                }
                {
                    activeTab?.name == "Therapist Reminder" && <TherapistReminder />
                }

            </div>
        </div>
    );
}

export default PanelEmail;